import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../constants";
import { setPtToken } from "./ptAuth";

// Handles the post-Google-OAuth redirect for Poodle Talk family accounts.
// URL fragment looks like:  #session_id=xxxxxxxxxxxx
// On success, stores the session_token in localStorage and bounces to home.
export default function PoodleTalkAuthCallback({ onDone }) {
  const [status, setStatus] = useState("processing");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      setStatus("error");
      setErrorMsg("Missing session_id");
      return;
    }
    const session_id = m[1];

    axios
      .post(`${API}/poodletalk/auth/session`, { session_id })
      .then((res) => {
        const user = res.data;
        if (user?.session_token) setPtToken(user.session_token);
        window.history.replaceState({}, "", "/");
        setStatus("ok");
        onDone && onDone(user);
      })
      .catch((err) => {
        const msg = err?.response?.data?.detail || err?.message || "Could not sign in";
        setErrorMsg(msg);
        setStatus("error");
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (status === "error") {
    return (
      <div
        data-testid="pt-auth-error"
        className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#FFF7D6] to-[#FCEAEA] p-6"
      >
        <div className="max-w-md text-center bg-white/90 rounded-3xl p-8 shadow-xl border border-white/40">
          <div className="text-5xl mb-3">🐩</div>
          <p className="text-2xl font-bold mb-2 text-[#4A4A4A]">We couldn't sign you in</p>
          <p className="text-sm text-[#6B6B6B] mb-6">{errorMsg}</p>
          <button
            onClick={() => {
              window.history.replaceState({}, "", "/");
              onDone && onDone(null);
            }}
            data-testid="pt-auth-error-back"
            className="inline-block px-6 py-2 bg-[#A55B64] text-white rounded-full text-sm hover:bg-[#8A4951] transition-all"
          >
            Back to Poodle Talk
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      data-testid="pt-auth-processing"
      className="min-h-screen flex items-center justify-center bg-gradient-to-b from-[#FFF7D6] to-[#FCEAEA]"
    >
      <div className="text-center">
        <div className="animate-bounce text-6xl mb-4">🐩</div>
        <p className="text-base text-[#4A4A4A] font-medium">Signing you in to access the Poodle Talk App…</p>
      </div>
    </div>
  );
}
